import { Chip, Typography, useTheme } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';

import { TextEllipsis } from 'core/elements';
import { Color, Level, Size, Variant } from 'theme/enums';

interface IProps {
  marketingMemo?: string | null;
  truncate?: boolean;
  inline?: boolean;
}

export const ExternalMarketingMemo = ({
  marketingMemo,
  truncate = false,
  inline = false,
}: IProps) => {
  const theme = useTheme();

  if (!marketingMemo) {
    return null;
  }

  // warning[700] is scheme-aware (dark brown in light, light amber in dark) — legible on both.
  if (inline) {
    return truncate ? (
      <TextEllipsis
        content={marketingMemo}
        maxRows={2}
        level={Level.BODY_XS}
        sx={{ color: theme.palette.custom.warning.main }}
      />
    ) : (
      <Typography level={Level.BODY_XS} sx={{ color: theme.palette.custom.warning.main }}>
        {marketingMemo}
      </Typography>
    );
  }

  return (
    <Chip
      color={Color.WARNING}
      variant={Variant.SOFT}
      size={Size.SM}
      startDecorator={
        <Warning weight="bold" style={{ fontSize: 19, color: theme.palette.custom.warning.main }} />
      }
      slotProps={truncate ? { label: { sx: { minWidth: 0, overflow: 'hidden' } } } : undefined}
      sx={{
        gap: 0.5,
        fontWeight: 600,
        borderRadius: 3,
        padding: '4px',
        backgroundColor: theme.palette.custom.warning.light,
        color: theme.palette.warning[700],
        ...(truncate ? { minWidth: 0, maxWidth: '100%' } : { textWrap: 'auto' }),
      }}
    >
      {truncate ? (
        <TextEllipsis
          content={marketingMemo}
          maxRows={2}
          level={Level.BODY_XS}
          sx={{ color: 'inherit', fontWeight: 600 }}
        />
      ) : (
        marketingMemo
      )}
    </Chip>
  );
};
